import { shallowRef } from 'vue';

import { getDatasetUrl } from '@/assets';

const cityStateOptions = shallowRef([]);
let loadingPromise = null;

async function loadCityStateOptions() {
  if (cityStateOptions.value.length > 0) {
    return cityStateOptions.value;
  }
  if (loadingPromise) {
    return loadingPromise;
  }
  loadingPromise = (async () => {
    try {
      const url = getDatasetUrl('social_listening_city_state_options.json');
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      cityStateOptions.value = await response.json();
    } catch {
      cityStateOptions.value = [];
    }
    loadingPromise = null;
    return cityStateOptions.value;
  })();
  return loadingPromise;
}

export function stripLocationObject(location) {
  if (!location || typeof location !== 'object') {
    return location;
  }
  const { city, administrativeDivision, country } = location;
  return {
    city: city ?? null,
    administrativeDivision: administrativeDivision ?? null,
    country: country ?? null,
  };
}

export function useLocationOptions() {
  function lookupLocationsInOptions(locations) {
    if (!locations?.length || !cityStateOptions.value?.length) {
      return locations;
    }
    return locations.map((location) => {
      const { city, administrativeDivision, country } = location;
      const matchingOption = cityStateOptions.value.find((option) => {
        const value = option.value || option;
        return (
          value.city === city &&
          value.administrativeDivision === administrativeDivision &&
          value.country === country
        );
      });
      if (matchingOption) {
        return matchingOption.value || matchingOption;
      }
      return location;
    });
  }

  return {
    cityStateOptions,
    lookupLocationsInOptions,
    loadCityStateOptions,
    stripLocationObject,
  };
}
